import axiosDmsInstance from './axiosDmsInstance';
import { handleApiError } from '../../common/util';
import { ITechComment, ITechCommentPost } from '../../models/dms/technicianComments.model';

export const getTechnicianComments = async (repairOrderNumber: number) => {
  try {
    const url = `/api/workshop/repairOrder/v1/${repairOrderNumber}/techComments`;
    let params = {} as any;

    const response = await axiosDmsInstance.get<ITechComment[]>(`${url}`, {
      params
    });

    return response.data;
  } catch (err: any) {
    return handleApiError('getTechnicianComments', err);
  }
};

export const postTechnicianComment = async (comment: ITechCommentPost) => {
  try {
    const url = `/api/workshop/repairOrder/v1/addTechComment`;
    let params = {} as any;

    const response = await axiosDmsInstance.post(`${url}`, comment, {
      params
    });

    return response.data;
  } catch (err: any) {
    return handleApiError('postTechnicianComment', err);
  }
};